import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box } from "@mui/material";
import { useStyles } from "./my-hr-payroll-yearly-data-tooltip.style";
import { OcCurrency } from "oc/components";

interface MyHrPayrollYearlyDataTooltipTitleProps {
  item: {
    month: string | number;
    netWage: number;
  };
}

export const MyHrPayrollYearlyDataTooltipTitle: React.FC<
  MyHrPayrollYearlyDataTooltipTitleProps
> = ({ item }) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const monthName = moment(`2020-${item.month}`)
    .locale(i18n.language)
    .format("MMMM");
  return (
    <Box color="#fff" borderRadius="8px" padding="12px 0px">
      <Box textAlign="center" className={classes.modalTitle}>
        {monthName}
      </Box>
      <Box className={classes.modalContent}>
        <Box pr="16px">{t("MY_HR_NET_WAGE")}</Box>
        <Box>{OcCurrency({ value: item.netWage })}</Box>
      </Box>
    </Box>
  );
};

export default MyHrPayrollYearlyDataTooltipTitle;
